import { Component, OnInit, Input } from '@angular/core';
import { FeaturesMap, Flight } from '@ibe.models/flight.model.lib';
import { INDRASegment } from '@ibe.models/segment.indra.model.lib';
import { SidebarService } from '@ibe/services/ui';
import { AIRPLANE_EQUIPMENT_WITH_LOGOS, EQUIPMENT_CODE_BUS } from '@ibe.config';
import { INDRABookingSearchService } from '@ibe.services/booking-search.indra.service';
import { INDRAStorageService } from '@ibe.services/storage.indra.service';
import { Router } from '@angular/router';

@Component({
	selector: 'app-extras-block',
	templateUrl: './extras-block.indra.component.html',
	styleUrls: ['./extras-block.component.scss']
})
export class INDRAExtrasBlockComponent implements OnInit {

	@Input()
	flight;

	@Input()
	feature;

	@Input()
	flightDetail;

	@Input()
	featureName;

	airplaneName;
	airplaneLogo;
	airLinesOperationCarrier: string[] = [];
	busSegments: INDRASegment[] = [];

	ancillaryList: any;
	featureQuantity;
	price: string;
	extraDescription: string;

	constructor(private sidebarService: SidebarService,
		private bookingSearchService: INDRABookingSearchService,
		private storageService: INDRAStorageService,
		private router: Router) { }

	ngOnInit() {
		if (this.router.url.indexOf('review-your-trip') > 0 && this.feature) {
			this.ancillaryList = this.storageService.get('INDRAAncillariesShoppingCartService.shoppingCart');
			this.featureQuantity = this.ancillaryList.itemsAdded.filter(item => item.type == this.feature.type && item.flightId == this.flightDetail.item.details.idFlight).length;
		}

		let equipmentWithLogo = null;
		let haulType = null;
		this.flight.listSegment.forEach(segment => {
			if (!this.airLinesOperationCarrier.includes(segment.operationCarrier)) {
				this.airLinesOperationCarrier.push(segment.operationCarrier);
			}
			if (segment.equipment === EQUIPMENT_CODE_BUS) {
				this.busSegments.push(segment);
			}
			if (AIRPLANE_EQUIPMENT_WITH_LOGOS.includes(segment.equipment)) {
				equipmentWithLogo = segment.equipment;
				haulType = segment.haul;
			}
		});

		if (equipmentWithLogo) {
			this.airplaneLogo = this.bookingSearchService.INDRA_getNEOEquipmentLogoName(equipmentWithLogo, haulType);
			this.airplaneName = equipmentWithLogo;
		}

		if (this.feature.description !== 'for free') {
			const description = this.feature.description.split(' ');
			this.price = description[1] + ' ' + description [2];
			this.extraDescription = description[0];
		} else {
			this.extraDescription = 'forFree';
		}
	}

	INDRA_handleOpenExtra(action: { route: string }) {
		this.sidebarService.openSidebar([action.route, { flight: this.flightDetail.item.details.assignedFlightId }]);
	}

	hasChanged(feature) {
		return new FeaturesMap(this.flight).hasChanged(feature);
	}

	featureEnable(feature) {
		return new FeaturesMap(this.flight).getEnable(feature);
	}

	featureHasType(feature, type) {
		return feature.type == type;
	}

	featureCost(feature) {
		return new FeaturesMap(this.flight).getCost(feature);
	}

	featureCount(feature) {
		return new FeaturesMap(this.flight).getCount(feature);
	}

	INDRA_printAirlineLogo() {
		let airlineLogo;
		if (this.busSegments.length > 0) {
			return 'icons.svg#plane_related--plane_and_bus';
		} else {
			if (this.airLinesOperationCarrier.length > 1) {
				airlineLogo = 'Multiple';
			} else {
				airlineLogo = this.airLinesOperationCarrier[0];
			}
			return this.bookingSearchService.INDRA_buildAirlineLogoName(airlineLogo);
		}
	}

	INDRA_printAirlineName() {
		if (this.airLinesOperationCarrier.length > 1 && this.busSegments.length === 0) {
			return 'Multiple Airlines';
		} else if (this.airLinesOperationCarrier.length >= 1 && this.busSegments.length > 0) {
			return 'Airlines and Bus';
		} else {
			if (this.flight.airLinesTranslation && this.flight.airLinesTranslation[this.airLinesOperationCarrier[0]]) {
				return this.flight.airLinesTranslation[this.airLinesOperationCarrier[0]].name;
			} else {
				const airlineName =
					this.bookingSearchService.INDRA_getFlightSearchAirplaneInfo(this.airLinesOperationCarrier[0]);
				return (airlineName ? airlineName.name : this.airLinesOperationCarrier[0]);
			}
		}
	}
}
